export default "__VITE_ASSET__CfOK4gs$__"